export default __webpack_public_path__ + "static/media/programmenucard-small@2x.fe239465.png";